import * as React from "react";
const SvgFiRrCloudExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M12 17.5a1 1 0 0 1-1-1V10a1 1 0 1 1 2 0v6.5a1 1 0 0 1-1 1m0 1.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 12 19m11.998-4.565c.001-.02.001.016 0 0m-6.024-7.262a1.03 1.03 0 0 1-.742-.569c-1.551-3.271-5.142-5.1-8.735-4.438a7.95 7.95 0 0 0-6.384 6.502 8.2 8.2 0 0 0 .033 2.889c.06.309-.073.653-.346.901a5.41 5.41 0 0 0-1.801 4.043c0 3.032 2.467 5.5 5.5 5.5h1.5a1 1 0 1 0 0-2h-1.5c-1.93 0-3.5-1.57-3.5-3.5 0-.98.407-1.891 1.146-2.562.786-.715 1.155-1.773.963-2.763a6.1 6.1 0 0 1-.024-2.181c.403-2.422 2.365-4.421 4.771-4.862 2.75-.499 5.385.835 6.567 3.329a3.02 3.02 0 0 0 2.158 1.673 5.51 5.51 0 0 1 4.417 5.381c-.007 2.861-2.236 5.272-5.075 5.488a1 1 0 0 0 .075 1.997q.038 0 .077-.003c3.848-.293 6.874-3.692 6.922-7.562-.043-3.525-2.565-6.572-6.024-7.262z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudExclamation;
